import AdminLayout from "../../../components/admin/layout/AdminLayout";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";
import BidRequest from "../../../components/common/bid/BidRequest";

function BidRequestPage() {
  const { userType } = useAuthStore();

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <div className="p-0">
        <BidRequest />
      </div>
    </AdminLayout>
  );
}

export default BidRequestPage;
